import { useEffect } from 'react';

import { axiosPrivate } from '../Api/axios';
import useAuth from './useAuth';
import useRefreshToken from './useRefreshToken';
// attach interceptpr to  instance axiosprivate
const useAxiosPrivate = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {
        // interceptors <=> js event linstners, we need to atach them and also detach them in some point
        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {
                // if there is no headers , in the initial request
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async (error) => {
                // get previos request fron axios
                const prevRequest = error?.config;
                console.log('error occured while sending the request, maybe short time token has expired', error?.response?.status, error);
                // check if forbidden 'once' [acces token fails]
                if (error?.response?.status === 403 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    if(!newAccessToken){
                        window.location.reload();
                    }
                    prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return axiosPrivate(prevRequest);
                }
                return Promise.reject(error);
            }
        );
        // console.log("Whet happened");
        // clean / detach / remove interceptors
        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        };
    }, [auth, refresh]);

    return axiosPrivate;
};

export default useAxiosPrivate;